import React from 'react'
import StarRatings from '../StarRatings/StarRatings'
import { generateReviewsBadgeText } from '@/domain/centerReviews/generateReviewsBadgeText'
type TProps = {
  uniqueKey: string
  count: number
  isVerified: boolean
  rating: number
  shouldDefaultRegionalize: boolean
  overrideVerified?: boolean
}

function CardReviewsRating({
  uniqueKey,
  count,
  isVerified,
  rating,
  shouldDefaultRegionalize = false,
  overrideVerified = false
}: TProps): JSX.Element {
  const hasReviews = count > 0

  return (
    <div className="flex h-4 items-center gap-2">
      {hasReviews && (
        <StarRatings
          rating={rating}
          starRatedColor="#FFBE5C"
          starSpacing="2px"
          numberOfStars={5}
          uniqueKey={uniqueKey}
          starDimension="16px"
          starRatingsStyle="flex items-center"
          svgIconViewBox="0 0 13 12"
          svgIconPath="M11.5 4.241H7.73L6.477.31a.522.522 0 0 0-.954 0L4.27 4.241H.5a.5.5 0 0 0-.3.9l3.01 2.3-1.26 3.867a.5.5 0 0 0 .77.559L6 9.481l3.28 2.383a.5.5 0 0 0 .77-.559L8.794 7.442l3.01-2.3a.5.5 0 0 0-.3-.9l-.004-.001Z"
        />
      )}
      <div className="relative top-px text-sm font-medium text-gray-800">
        {generateReviewsBadgeText({
          hasReviews,
          isVerified,
          shouldDefaultRegionalize,
          overrideVerified,
          count
        })}
      </div>
    </div>
  )
}

export default CardReviewsRating
